var CoverListVariables     = require("app/theme/styles/repeaters/CoverListVariables"),
    ThumbnailListVariables = require("app/theme/styles/repeaters/ThumbnailListVariables"),
    themeVars              = require("app/theme/variables");

module.exports = {

    /**
     * The direction of the arrangement.
     *
     * @type    {string}
     * @public
     */
    direction: "horizontal",

    /**
     * The amount of spacing between children.
     *
     * @return  {number}  The amount of spacing
     * @public
     */
    childSpacing: function() {
        return themeVars.getGridInnerSpacingHorizontalPx();
    },

    /**
     * The amount of padding before the first child.
     *
     * @return {number}  The padding
     * @public
     */
    padBefore: function() {
        return Math.max(themeVars.safeAreaInsetLeft + themeVars.getPageMarginPx(), themeVars.getPageMarginLargePx());
    },

    /**
     * The amount of padding after the last child.
     *
     * @return {number}  The padding
     * @public
     */
    padAfter: function() {
        return themeVars.safeAreaInsetRight + themeVars.getPageMarginPx();
    },

    /**
     * Sets the step size with which the amount of rows/columns dividing the
     * viewport should be incremented.
     *
     * For example: A `divisionStep` value of 2 will divide the viewport into 0,
     * 2, 4, 6 etc. columns/rows.
     *
     * @return  {number}  The step size
     * @public
     */
    divisionStep: function() {
        var repeater        = this.repeater,
            childFormat     = repeater.get("childFormat"),
            childFormFactor = repeater.get("childFormFactor"),
            childSize       = repeater.get("childSize");

        switch (childFormat) {
            case "thumbnail":
                return ThumbnailListVariables.getDivisionStep(childFormFactor, childSize);
            case "cover":
            default:
                return CoverListVariables.getDivisionStep(childFormFactor, childSize);
        }
    },

    /**
     * Sets an optional offset to apply when dividing the viewport into
     * rows/columns. The offset value must be positive and will only be applied
     * if the viewport can accommodate 1 or more rows/columns.
     *
     * For example: A [`divisionStep`]{@link
     * app.ui.repeaters.ColumnatedListArranger#divisionStep} value of 1, and a
     * `divisionOffset` value of 0.5 will result in 0, 1.5, 2.5, 3.5 etc.
     * columns/rows.
     *
     * @return  {number}  The offset
     * @public
     */
    divisionOffset: function() {
        var repeater        = this.repeater,
            childFormat     = repeater.get("childFormat"),
            childFormFactor = repeater.get("childFormFactor"),
            childSize       = repeater.get("childSize");

        switch (childFormat) {
            case "thumbnail":
                return ThumbnailListVariables.getDivisionOffset(childFormFactor, childSize);
            case "cover":
            default:
                return CoverListVariables.getDivisionOffset(childFormFactor, childSize);
        }
    },

    /**
     * The maximum width of a cover in pixels.
     *
     * @returns  {number}  The maximum width
     * @public
     */
    maxChildWidth: function() {
        var viewportWidth   = this.getOption("viewportWidth"),
            childSpacing    = this.getOption("childSpacing"),
            padBefore       = this.getOption("padBefore"),
            padAfter        = this.getOption("padAfter"),
            repeater        = this.repeater,
            childFormat     = repeater.get("childFormat"),
            childFormFactor = repeater.get("childFormFactor"),
            childSize       = repeater.get("childSize"),
            availableWidth,
            maxChildWidth,
            minColumns;

        availableWidth = viewportWidth
            + childSpacing // One childSpacing worth of overflow
            - padBefore // Compensate for left padding
            - padAfter; // Compensate for right padding

        switch (childFormat) {
            case "thumbnail":
                maxChildWidth = ThumbnailListVariables.getMaxChildWidth(childFormFactor, childSize);
                minColumns    = ThumbnailListVariables.getMinColumns(childFormFactor, childSize);
                break;
            case "cover":
            default:
                maxChildWidth = CoverListVariables.getMaxChildWidth(childFormFactor, childSize);
                minColumns    = CoverListVariables.getMinColumns(childFormFactor, childSize);
                break;
        }

        return Math.min(
            availableWidth / minColumns,
            maxChildWidth
        );
    },

    /**
     * Whether to round values of cell width/height and arrangement
     * transform to integer pixels values.
     *
     * @type    {number}
     * @public
     */
    roundPixels: true
};

